//////////////////////////////////
// IMPORTING MODULES
//////////////////////////////////

import { Menu, X } from "lucide-react";
import React, { useState } from "react";

//////////////////////////////////
// COMPONENT: NAVBAR
//////////////////////////////////

const Navbar = (): JSX.Element => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);

  const scrollToSection = (sectionId: string): void => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 w-full z-50 bg-[#0e1220]/95 backdrop-blur-sm border-b border-gray-800 ">
      <div className="max-w-7xl mx-auto px-10">
        <div className="flex justify-between items-center h-28">
          <div className="flex items-center">
            <img
              src="../images/logo.png"
              width={70}
              className="mr-2"
              alt="Flight Trail Logo"
            />
            <span className="text-xl font-bold">Flight Trail</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            <button
              onClick={() => scrollToSection("home")}
              className="text-gray-300 hover:text-[#2ab8ff] transition-colors"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection("features")}
              className="text-gray-300 hover:text-[#2ab8ff] transition-colors"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection("faq")}
              className="text-gray-300 hover:text-[#2ab8ff] transition-colors"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="text-gray-300 hover:text-[#2ab8ff] transition-colors"
            >
              Contact
            </button>
          </div>

          <div className="hidden md:flex space-x-4 cursor-pointer">
            <button
              onClick={() => scrollToSection("download")}
              className="px-6 py-4 bg-gradient-to-r bg-[#2ab8ff]  text-[#0e1220] rounded-lg hover:shadow-lg hover:shadow-[#2ab8ff]/30 transition-all font-semibold"
            >
              Get Started
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 space-y-4">
            <button
              onClick={() => scrollToSection("home")}
              className="block w-full text-left text-gray-300 hover:text-[#2ab8ff] py-2"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection("features")}
              className="block w-full text-left text-gray-300 hover:text-[#2ab8ff] py-2"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection("faq")}
              className="block w-full text-left text-gray-300 hover:text-[#2ab8ff] py-2"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="block w-full text-left text-gray-300 hover:text-[#2ab8ff] py-2"
            >
              Contact
            </button>
            <div className="flex flex-col space-y-2 pt-4">
              <button
                onClick={() => scrollToSection("download")}
                className="w-full px-4 py-2 text-center bg-gradient-to-r from-[#2ab8ff] to-[#0066cc] text-white rounded-lg font-semibold"
              >
                Get Started
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

//////////////////////////////////
// EXPORTING NAVBAR
//////////////////////////////////

export default Navbar;
